import React, { useMemo } from 'react';
import LinkModel from '../../Types/LinkModel';
import Button from '../../Components/Button';
import clsx from 'clsx';

export interface BannerItemProps {
  title?: string;
  bodyText?: string;
  imageUrl?: string;
  imageAlt?: string;
  backgroundColor?: string;
  mobileImageUrl?: string;
  mobileImageAlt?: string;
  link?: LinkModel;
  overlay: boolean;
  numPerRow: number;
  className?: string;
}

const BannerItem = (props: BannerItemProps) => {
  const {
    title,
    bodyText,
    imageUrl,
    backgroundColor,
    mobileImageUrl,
    link,
    overlay,
    numPerRow,
    imageAlt,
    mobileImageAlt,
    className,
  } = props;

  const spanClasses = useMemo(() => {
    switch (numPerRow) {
      default:
        return '';
      case 5:
        return 'last:col-span-2 md:last:col-span-3 lg::col-span-1 [&:nth-child(2)]:col-span-1 md:[&:nth-child(2)]:col-span-3 lg:[&:nth-child(2)]:col-span-1';
    }
  }, [numPerRow]);

  const bannerItemImageClasses =
    'lg:h-full aspect-[unset] row-start-1 col-start-1 w-full object-cover';

  return (
    <a
      className={clsx(
        'grid grid-cols-1 banner-item',
        spanClasses,
        className
      )}
      href={link?.href}
      style={{ backgroundColor }}
    >
      {(!!mobileImageUrl && (
        <>
          <img
            className={bannerItemImageClasses}
            src={mobileImageUrl}
            alt={mobileImageAlt ?? imageAlt}
          />
          <img
            className={bannerItemImageClasses}
            src={imageUrl}
            alt={imageAlt}
          />
        </>
      )) || (
          <img
            className={bannerItemImageClasses}
            src={imageUrl}
            alt={imageAlt}
          />
        )}

      <div
        className={clsx(
          'w-full h-full col-start-1 row-start-1 z-[3] flex flex-col items-start justify-end mx-auto p-4 box-border lg:p-6',
          numPerRow < 3 && 'xl'
        )}
      >
        <h2 className="font-satoshi-bold text-lg">{title}</h2>
        {bodyText && numPerRow <= 4 && (
          <p className="text-lg mt-2 leading-normal">{bodyText}</p>
        )}
        {link?.text && link.href && (
          <button className="mt-4 btn btn--large btn--inverted-primary">
            {link.text}
          </button>
        )}
      </div>
      {overlay && (
        <div className="w-full h-full col-start-1 row-start-1 z-[2] pointer-events-none bg-[rgba(0,0,0,0.551)]"></div>
      )}
    </a>
  );
};

export default BannerItem;
